import { render, staticRenderFns } from "./PosCashDesk.vue?vue&type=template&id=477e42f3&scoped=true"
import script from "./PosCashDesk.vue?vue&type=script&lang=js"
export * from "./PosCashDesk.vue?vue&type=script&lang=js"
import style0 from "./PosCashDesk.vue?vue&type=style&index=0&id=477e42f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e42f3",
  null
  
)

export default component.exports